<template>
  <div>
    <div class="columns is-vcentered is-gapless is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span class="is-size-6">Est présent dans {{poles.length}} pôle(s)</span>
      </div>
    </div>
    <table class="table is-fullwidth is-hoverable is-last-fixed-small is-marginless-bottom  is-radius-bottom-left is-radius-bottom-right">
      <thead>
        <tr class="is-size-6">
          <th>Nom</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="pole in poles" :key="pole.pk" class="is-size-6">
        <td>
          <router-link :to="{name: 'PoleVue', params: {id: pole.pk}}">{{pole.name}}</router-link>
        </td>
        <td class="has-text-centered actions">
            <display-button-list :buttons="poleButtonList" :data="pole"
                                ></display-button-list>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'UserPolesList',
    data () {
      return {
        sortBy: {
          first_name: {
            order: null,
            sort: false
          },
          last_name: {
            order: null,
            sort: false
          },
          email: {
            order: null,
            sort: false
          }
        },
        poleButtonList: [
          {
            action: (id) => {
              this.$router.push({name: 'PoleVue', params: {id}})
            },
            needProfile: ['admin'],
            icon: 'fa-eye'
          }
        ]
      }
    },
    props: {
      sourcePoles: {
        type: Array,
        required: true,
        default: []
      }
    },
    computed: {
      poles () {
        return this.sourcePoles
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserPolesList.vue